import { render, staticRenderFns } from "./ListCotacoes.vue?vue&type=template&id=53b2f6d6&scoped=true"
import script from "./ListCotacoes.vue?vue&type=script&lang=js"
export * from "./ListCotacoes.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/listCard.css?vue&type=style&index=0&id=53b2f6d6&prod&scoped=true&lang=css&external"
import style1 from "./ListCotacoes.vue?vue&type=style&index=1&id=53b2f6d6&prod&lang=scss"
import style2 from "./ListCotacoes.vue?vue&type=style&index=2&id=53b2f6d6&prod&lang=css"
import style3 from "./ListCotacoes.vue?vue&type=style&index=3&id=53b2f6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2f6d6",
  null
  
)

export default component.exports